import { Dimensions } from 'editor/src/store/design/types';

// eslint-disable-next-line import/prefer-default-export
export const EMPTY_PREVIEW_DIM: Dimensions = { width: 160, height: 160 };
